module.exports = __webpack_public_path__ + "img/new_realpleyer.8c2811d2.png";